import { ICoordinate2D } from "Data";

export class ReportDataServiceHelper {
    static compareDispersionCoordinates(oldCoordinates: Array<ICoordinate2D>, newCoordinates: Array<ICoordinate2D>): boolean {
        if (oldCoordinates.length !== newCoordinates.length) {
            return false;
        }

        for (var i = 0; i < oldCoordinates.length; i++) {
            if (oldCoordinates[i].X !== newCoordinates[i].X || oldCoordinates[i].Y !== newCoordinates[i].Y) {
                return false;
            }
        }

        return true;
    }
}